import { getDay } from 'date-fns';
import { Studente, EventoCalendarioDTO } from '../../../../api-clients/generated/services';

export type ChipState = 'libero' | 'assenza' | 'pasta-in-bianco' | 'chiusura';

const DAY_MAP: Record<string, number> = {
  'domenica': 0, 'lunedi': 1, 'martedi': 2, 'mercoledi': 3,
  'giovedi': 4, 'venerdi': 5, 'sabato': 6,
};

export function getExcludedDays(studente?: Studente | null): number[] {
  const giorniChiusura = studente?.scuola?.giorniChiusura;
  if (!giorniChiusura || giorniChiusura.length === 0) {
    return [0, 6]; // default sab+dom
  }
  return giorniChiusura
    .map(g => DAY_MAP[g.toLowerCase()])
    .filter(d => d !== undefined);
}

export function isExcludedDay(date: Date, excludedDays: number[]): boolean {
  return excludedDays.includes(getDay(date));
}

export function getEventState(dateDDMMYYYY: string, eventi: EventoCalendarioDTO[]): ChipState {
  for (const ev of eventi) {
    if (ev.data === dateDDMMYYYY && ev.stato === 'ATTIVO') {
      switch (ev.tipo) {
        case 'CHIUSURA_SCOLASTICA': return 'chiusura';
        case 'ASSENZA': return 'assenza';
        case 'PASTA_IN_BIANCO': return 'pasta-in-bianco';
      }
    }
  }
  return 'libero';
}

export function hasChiusura(dateDDMMYYYY: string, eventi: EventoCalendarioDTO[]): boolean {
  return eventi.some(ev =>
    ev.data === dateDDMMYYYY && ev.tipo === 'CHIUSURA_SCOLASTICA'
  );
}

export function getSospesoMessage(studente?: Studente | null): string | null {
  if (!studente?.isSospeso) return null;
  return studente.isPresenteRicaricaDaPagare
    ? 'Servizio mensa sospeso: è necessario regolarizzare i pagamenti per riattivarlo.'
    : 'Il servizio mensa per questo studente è attualmente sospeso.';
}
